import { render, staticRenderFns } from "./MisTareas.vue?vue&type=template&id=4d97437e&scoped=true&lang=pug"
import script from "./MisTareas.vue?vue&type=script&lang=js"
export * from "./MisTareas.vue?vue&type=script&lang=js"
import style0 from "./MisTareas.vue?vue&type=style&index=0&id=4d97437e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d97437e",
  null
  
)

export default component.exports